export default __webpack_public_path__ + "static/media/Virtuoz_logo.1ab40f47.png";